import { useState, useCallback } from 'react';
import { callApi } from '../utils/apiClient';
import { API_ENDPOINTS } from '../config/api/apiCall';


export const useHSNList = () => {
    const [dataHsn, setDataHsn] = useState([]);

    const loadHSNCode = useCallback(async () => {
        const para = {
            CompanyID: localStorage.getItem('companyid'),
        };

        try {
            const result = await callApi(
                API_ENDPOINTS.GetAllHSNLists,
                'POST',
                { 'Content-Type': 'application/json' },
                para
            );

            if (result && result.length > 0) {
                const updatedData =
                    Array.isArray(result) && !result.includes('')
                        ? [''].concat(result)
                        : result;

                setDataHsn(updatedData);
            } else {
                alert('Product HSN not found');
            }
        } catch (error) {
            alert(error.message);
        }
    }, []);

    return {
        dataHsn,
        loadHSNCode,
    };
};
